import { useState } from 'react';

const useFavoritesPageState = () => {
    const [areButtonsDisabled, setAreButtonsDisabled] = useState(false);

    return {
        areButtonsDisabled,
        disableButtons: () => setAreButtonsDisabled(true),
        enableButtons: () => setAreButtonsDisabled(false)
    };
};

export default useFavoritesPageState;
